export enum CourseType {
  Learnership,
  SkillsProgramme,
  ShortCourse,
}
